export const initialState = {
  NA: {
    dataRetrieved: false,
    pending: false,
    data: [],
    error: null,
  },
  EMEA: {
    dataRetrieved: false,
    pending: false,
    data: [],
    error: null,
  },
  APLA: {
    dataRetrieved: false,
    pending: false,
    data: [],
    error: null,
  },
  GC: {
    dataRetrieved: false,
    pending: false,
    data: [],
    error: null,
  },
};

const retailStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_RETAIL_STORE_DATA_PENDING':
      return {
        ...state,
        [action.geo]: {
          ...state[action.geo],
          pending: true,
        },
      };
    case 'GET_RETAIL_STORE_DATA_SUCCESS':
      return {
        ...state,
        [action.geo]: {
          ...state[action.geo],
          pending: false,
          data: action.data,
          dataRetrieved: true,
        },
      };
    case 'GET_RETAIL_STORE_DATA_ERROR':
      return {
        ...state,
        [action.geo]: {
          ...state[action.geo],
          pending: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default retailStoreReducer;

// Selectors for specific geo
export const rdxRetailDeviceDataPending = (state, geo) => state.retailDeviceData[geo]?.pending;
export const rdxRetailDeviceDataReady = (state, geo) => state.retailDeviceData[geo]?.dataRetrieved;
export const rdxRetailDeviceData = (state, geo) => state.retailDeviceData[geo]?.data;
export const rdxRetailDeviceDataError = (state, geo) => state.retailDeviceData[geo]?.error;
